import {find} from 'lodash';

/**
 * This Interface is a clone of MDN's fullsceen API.
 * camelCase is used inconsistently in their API but
 * for consistency is replicated in this Interface.
 * https://developer.mozilla.org/en-US/docs/Web/API/Fullscreen_API
 */
interface IFullScreenApi {
  exitFullscreen: string;
  fullscreenElement: string;
  fullscreenEnabled: string;
  fullscreenchange: string;
  fullscreenerror: string;
  requestFullscreen: string;
  isFullScreen: string;
}

const spec = {
  exitFullscreen: 'exitFullscreen',
  fullscreenElement: 'fullscreenElement',
  fullscreenEnabled: 'fullscreenEnabled',
  fullscreenchange: 'fullscreenchange',
  fullscreenerror: 'fullscreenerror',
  requestFullscreen: 'requestFullscreen',
  isFullScreen: 'fullscreen'
} as IFullScreenApi;

const webkit = {
  exitFullscreen: 'webkitExitFullscreen',
  fullscreenElement: 'webkitFullscreenElement',
  fullscreenEnabled: 'webkitFullscreenEnabled',
  fullscreenchange: 'webkitfullscreenchange',
  fullscreenerror: 'webkitfullscreenerror',
  requestFullscreen: 'webkitRequestFullscreen',
  isFullScreen: 'webkitIsFullScreen'
} as IFullScreenApi;

const moz = {
  exitFullscreen: 'exitFullscreen',
  fullscreenElement: 'mozFullScreenElement',
  fullscreenEnabled: 'mozFullScreenEnabled',
  fullscreenchange: 'mozfullscreenchange',
  fullscreenerror: 'mozfullscreenerror',
  requestFullscreen: 'requestFullscreen',
  isFullScreen: 'fullscreen'
} as IFullScreenApi;

const ms = {
  exitFullscreen: 'msExitFullscreen',
  fullscreenElement: 'msFullscreenElement',
  fullscreenEnabled: 'msFullscreenEnabled',
  fullscreenchange: 'MSFullscreenChange',
  fullscreenerror: 'MSFullscreenError',
  requestFullscreen: 'msRequestFullscreen',
  isFullScreen: 'msIsFullScreen'
} as IFullScreenApi;

function getFullscreenApi() {
  const supportedVersion: string = find(
    [webkit.fullscreenEnabled, moz.fullscreenEnabled, ms.fullscreenEnabled, spec.fullscreenEnabled],
    (version): boolean => document[version]
  );

  return (
    find(
      [spec, webkit, moz, ms],
      apiVersion => apiVersion.fullscreenEnabled === supportedVersion
    ) || ({} as IFullScreenApi)
  );
}

export const fullscreenApiKeys = getFullscreenApi();
